import { render } from "./edit-supplier-fiscal.vue?vue&type=template&id=8b6ad7bc"
import script from "./edit-supplier-fiscal.vue?vue&type=script&lang=js"
export * from "./edit-supplier-fiscal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__